const PUSH = 'errors/PUSH';
const CLEAR = 'errors/CLEAR';

const pushError = ({ message, id }) => ({
  type: PUSH,
  message,
  id,
});

const clearErrors = () => ({ type: CLEAR });

export { PUSH, CLEAR, pushError, clearErrors };
